import { validateWordFn } from './validateWordFn'

const userManagementRule = [
  {
    property: 'roleName',
    ruleName: "notNull",
    message: "角色名称不能为空"
  }
]
const userEditRule = {
  userName: [{
    required: true,
    message: "登录账号不能为空",
    trigger: ['blur', 'change']
  },
  { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  userNameCn: [
    { validator: validateWordFn.bind(150), trigger: 'blur' }
  ],
  userType: [
    { required: true, message: "用户类型不能为空", trigger: 'blur'  },
  ],

  emailPassword: [
    { required: true, message: "邮箱密码不能为空", trigger: 'blur'  },
  ],
  email: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  emailAlias: [
    { validator: validateWordFn.bind(100), trigger: 'blur' }
  ],
  mobilePhone: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  tel: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  fax: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  wechat: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  qq: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  remark: [
    { validator: validateWordFn.bind(1000), trigger: 'blur' }
  ],
  inserviceStatus: [
    { required: true, message: "在职状态不能为空",  trigger: ['blur', 'change']  },
  ],
  dataAuthorityNames: [
    { required: true, message: "数据权限范围不能为空",  trigger: ['blur', 'change']  },
  ],
  userNameEn: [
    { validator: validateWordFn.bind(200), trigger: 'blur' }
  ],
  identityCardNo: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ]
}
const userInRule = {
  userName: [{
    required: true,
    message: "登录账号不能为空",
    trigger: ['blur', 'change']
  },
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  userNameCn: [
    {
      required: true,
      message: "中文名称不能为空",
      trigger: ['blur', 'change']
    },
    { validator: validateWordFn.bind(150), trigger: 'blur' }
  ],
  userType: [
    { required: true, message: "用户类型不能为空", trigger: 'blur'  },
  ],
  sex: [
    { required: true, message: "性别不能为空",  trigger: ['blur', 'change']  },
  ],
  emailPassword: [
    { required: true, message: "邮箱密码不能为空", trigger: 'blur'  },
  ],
  email: [
    { required: true, message: "邮箱不能为空", trigger: 'blur'  },
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  emailAlias: [
    { validator: validateWordFn.bind(100), trigger: 'blur' }
  ],
  mobilePhone: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  tel: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  fax: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  wechat: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  qq: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  remark: [
    { validator: validateWordFn.bind(1000), trigger: 'blur' }
  ],
  inserviceStatus: [
    { required: true, message: "在职状态不能为空",  trigger: ['blur', 'change']  },
  ],
  dataAuthorityNames: [
    { required: true, message: "数据权限范围不能为空",  trigger: ['blur', 'change']  },
  ],
  userNameEn: [
    { validator: validateWordFn.bind(200), trigger: 'blur' }
  ],
  identityCardNo: [
    { validator: validateWordFn.bind(50), trigger: 'blur' }
  ],
  defaultOfficeName:[
    { required: true, message: "默认组织不能为空",  trigger: ['blur', 'change']  }
  ],
  defaultCorpName:[
    { required: true, message: "默认结算公司不能为空",  trigger: ['blur', 'change']  }
  ]
}


export {
  userManagementRule, userEditRule,userInRule
}
